
export const startTempList = 'startTempConst/startTempList';
export const deleteStartTemp = 'startTempConst/deleteStartTemp';
export const modifyModel = 'startTempConst/modifyModel';
